import React from "react";
import { StaticImage } from "gatsby-plugin-image";

function ServicesModal({ closed }) {
  return (
    <div className="modal">
      <StaticImage
        onClick={closed}
        className="close"
        width={20}
        src="../images/close.svg"
        alt="Close"
      />
      <p>{localStorage.getItem("content")}</p>
    </div>
  );
}

export default ServicesModal;
